// Pick the first defined of two or three arguments.
export default function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/moment/src/lib/utils/defaults.js
// module id = 225
// module chunks = 0